import React, { Component } from "react";
import { connect } from "react-redux";

import PageComponent from "./PageComponent";

import {
  openPageViewer,
  setBlocLabel,
  setBlocUrl,
  setBlocIcon,
  setBlocApp
} from "Actions";

class Page extends Component {
  handleDisplayPage = page => {
    const { openPageViewer } = this.props;

    openPageViewer({
      isOpen: true,
      currentPage: page
    });
  };

  render() {
    const { setBlocLabel, setBlocUrl, setBlocIcon, setBlocApp } = this.props;
    return (
      <PageComponent
        {...this.props}
        openPageModal={this.handleDisplayPage}
        setBlocLabel={setBlocLabel}
        setBlocUrl={setBlocUrl}
        setBlocIcon={setBlocIcon}
        setBlocApp={setBlocApp}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  openPageViewer: viewer => dispatch(openPageViewer(viewer)),
  setBlocLabel: (index, order, value) =>
    dispatch(setBlocLabel(index, order, value)),
  setBlocUrl: (index, order, value) =>
    dispatch(setBlocUrl(index, order, value)),
  setBlocIcon: (index, order, value) =>
    dispatch(setBlocIcon(index, order, value)),
  setBlocApp: (index, order, value) => dispatch(setBlocApp(index, order, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Page);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Pages/Page/index.js